export default "__VITE_ASSET__DTjar8pr__"